import { NotLoggedInToWorkspaceError, } from '@lucidlink/sdk';
import { CurrentMemberKeyFactory, FilespacesKeyFactory, WorkspaceLoginStatusKeyFactory, WorkspacesKeyFactory, } from '#query-hooks';
import { appRoutes } from '#services';
export const clearWorkspaceData = async ({ error, params: { navigate, queryClient }, }) => {
    if (!(error instanceof NotLoggedInToWorkspaceError)) {
        // eslint-disable-next-line no-console -- warning if used with incorrect type
        return console.error(`Handler used with incorrect error type. Required error ${NotLoggedInToWorkspaceError.name}`);
    }
    const workspaceId = error.workspaceId;
    // removing cached WorkspaceMemberData in order to refresh privileges
    queryClient.removeQueries({
        queryKey: CurrentMemberKeyFactory.byWorkspace(workspaceId),
        exact: true,
    });
    await queryClient.refetchQueries({
        queryKey: WorkspaceLoginStatusKeyFactory.byWorkspace(workspaceId),
    });
    const queryData = queryClient.getQueryData(WorkspaceLoginStatusKeyFactory.byWorkspace(workspaceId));
    if (queryData && queryData.isLoggedIn) {
        void queryClient.removeQueries({
            queryKey: FilespacesKeyFactory.byWorkspace(workspaceId),
            exact: true,
        });
        void queryClient.removeQueries({
            queryKey: WorkspacesKeyFactory.all(),
            exact: true,
        });
        void queryClient.removeQueries({
            queryKey: WorkspaceLoginStatusKeyFactory.byWorkspace(workspaceId),
            exact: true,
        });
        await navigate(appRoutes.root());
    }
};
